import lodash from 'lodash'
import { produce } from 'immer'
import * as services from '@/pages/admit/train/service'
import {
  formatSearch,
  formatValues,
  formateFetch,
  getStoryOptions,
  cascaderValueMap,
} from '@/pages/admit/train/util'

const initialState = {
  currentId: undefined, // 当前选中的用户
  currentIndex: undefined,
  isLastDialog: false, // 是否最后一通会话
  isUpperTwo: 0, // 时间大于2分钟
  originReply: undefined, // 原版回复的内容
  finishedList: [], // 接待结束
  servingList: [], // 接待中
  toDoList: [], // 待接待
  allMessages: [], // 全部聊天信息
  finishedMessages: [], // 接待结束的数据
  trainSearch: {
    current_page: 1,
    page_size: 20,
    task_name: undefined,
  },
  page: {
    page: 1,
    seze: 10,
    task_name: undefined,
  },
  trainList: [],
  trainTotal: 0,
  groupList: [],
  messageMap: {}, // 所有聊天信息
  isFinish: false,
  finishDialog: [],
  iptVal: {}, // 所有顾客的输入框内容
  focusMessageId: null,
  storyOptions: [],
  storyValueMap: new Map(),
  storyNameMap: new Map(),
  isShortcuts: false, // 是否显示快捷短语
  topActiveVal: 0,
  orderMsgList: [],
  customGoodsMsg: {},
}

const TrainModel = {
  namespace: 'trainList',

  state: {
    ...lodash.cloneDeep(initialState),
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname === '/exam/admit/train') {
          dispatch({ type: 'fetchGroups' })
        }
      })
    },
  },
  effects: {
    *fetchTrainList({ payload = {} }, { call, put, select }) {
      const { userGroups } = yield select((store) => store.user)
      const { trainSearch } = yield select((store) => store.trainList)
      const params = formatSearch({
        ...trainSearch,
        ...payload,
        user_group_ids: userGroups || [],
      })
      const result = yield call(services.fetchTrainList, params)
      yield put({
        type: 'setState',
        payload: {
          trainSearch: {
            current_page: params.page,
            page_size: params.size,
            task_name: params.task_name,
          },
          trainList: result.data.task_infos,
          trainTotal: result.data.total,
        },
      })
      return result
    },

    // 获取训练内容
    *fetchGroups({ payload }, { call, select, put }) {
      const response = yield call(services.fetchGroups)
      yield put({
        type: 'setState',
        payload: {
          groupList: formatValues(response?.data?.groups),
        },
      })
    },

    // 获取在职员工
    *fetchEmployeeList({ payload }, { call, put, select }) {
      const result = yield call(services.fetchEmployeeList, payload)
      return result
    },

    // 根据分组id返回下面所有的案例
    *fetchAllCasesTotal({ payload }, { call, select, put }) {
      // console.log('fetchAllCasesTotal的参数',payload);
      const response = yield call(services.fetchAllCasesTotal, { ...payload })
      return response
    },

    // 开始训练
    *startTrain({ payload }, { call, select, put }) {
      const user_id = yield select((state) => state.user.user_id)
      const result = yield call(services.startTrain, { ...payload, user_id })
      // yield put({ type: 'fetchTrainList' })
      return result
    },

    // 发布和取消发布
    *relAndCancelTrain({ payload }, { call, put }) {
      const result = yield call(services.relAndCancelTrain, { ...payload })
      // yield put({ type: 'fetchTrainList' })
      return result
    },

    // 批量创建
    *createMany({ payload }, { call, put }) {
      const result = yield call(services.createMany, payload)
      return result
    },

    // 检测名字是否存在
    *exitTrainName({ payload }, { call, put }) {
      let result
      try {
        result = yield call(services.exitTrainName, payload)
      } catch {
        return result
      }

      return result
    },

    // 删除训练
    *deleteTrain({ payload }, { call, put }) {
      const result = yield call(services.deleteTrain, payload)
      // console.log(result);
      // yield put({ type: 'fetchTrainList' })
      return result
    },

    // 获取标签 list
    *tagList({ payload }, { call, put }) {
      const result = yield call(services.tagList, payload)
      return result
    },

    // 获取会话分组
    *phraseGroup({ payload }, { call, put }) {
      const result = yield call(services.phraseGroup, payload)
      return result
    },

    // 根据标签id查user list
    *usersByTag({ payload }, { call, put }) {
      const result = yield call(services.usersByTag, payload)
      return result
    },

    // tag list 且带上tag包含的user
    *tagsAndUsers({ payload }, { call, put }) {
      const result = yield call(services.tagsAndUsers, payload)
      return result
    },

    // 客服回答上传、获取下一条顾客消息
    *fetchNextMessage({ payload }, { call, select, put }) {
      const params = formateFetch({ ...payload })
      // const { data } = yield call(services.fetchNextMessage, params)
      const data = TESTDATAMESSAGEARR[1]
      // 原版回复出现的位置
      const temp = data.dialog_result.segments.map((item, index) => {
        item.isRight = false
        if (
          index !== data.dialog_result.segments.length - 1 &&
          data.dialog_result.segments.length > 1
        ) {
          item.isRight = true
        }
        return item
      })

      yield put({
        type: 'setState',
        payload: {
          isLastDialog: data.is_right_answer && data.next_segment.questions?.length === 0,
          lastSegment: data.next_segment.last_segment,
          isUpperTwo: data.latest_segment_birth_time,
          originReply:
            data.dialog_result.segments[data.dialog_result.segments.length - 1]?.origin_answers?.[0]
              ?.content,
          currentIndex: payload.index,
          currentId: payload.id,
          allMessages: {
            data: temp,
            cnick: data.dialog_result.cnick,
            snick: data.dialog_result.snick,
            orderInfo: data.dialog_result.order_info,
            shopInfo: data.dialog_result.shop_info,
            averResponseTime: data.dialog_result.aver_response_time,
            firstResponseTime: data.dialog_result.first_response_time,
            answerRate: data.dialog_result.answer_rate,
            aCount: data.dialog_result.a_count,
            qCount: data.dialog_result.q_count,
          },
        },
      })

      return data
    },

    *fetchAllStories(_, { call, select, put }) {
      const res = yield call(services.getAllStories)
      const storyOptions = getStoryOptions(res?.data?.groups || [])
      const { valueMap: storyValueMap, nameMap: storyNameMap } = cascaderValueMap(storyOptions)

      yield put({
        type: 'setState',
        payload: {
          storyOptions,
          storyValueMap,
          storyNameMap,
        },
      })
      return storyOptions
    },

    *evalTraining({ payload }, { call, put }) {
      yield call(services.evalTraining, payload)
    },
    // 体验页面评分
    *evalTraining_experince({ payload }, { call, put }) {
      yield call(services.evalTraining_experince, payload)
    },
    // 编辑模拟订单
    *editSimulatedOrder({ payload }, { call, put }) {
      const result = yield call(services.editSimulatedOrder, payload)
      return result
    },
    // 查询模拟订单信息
    *searchSimulatedOrder({ payload }, { call, put }) {
      const result = yield call(services.searchSimulatedOrder, payload)
      return result
    },
    // 模拟订单评价
    *evalMockOrder({ payload }, { call, put }) {
      const result = yield call(services.evalMockOrder, payload)
      return result
    },
    // 接待设置快捷短语查询
    *taskShortFind({ payload }, { call, put }) {
      const result = yield call(services.taskShortFind, payload)
      return result
    },
    // 手动结束会话
    *manualFinishReception({ payload }, { call, put }) {
      const result = yield call(services.manualFinishReception, payload)
      return result
    },
    // 结束会话后调用以让后端关闭会话
    *finishChat({ payload }, { call, put }) {
      const result = yield call(services.finishChat, payload)
      return result
    },
  },
  reducers: {
    setState: produce((state, action) => ({
      ...state,
      ...action.payload,
    })),
    resetState: produce(() => {
      return { ...lodash.cloneDeep(initialState) }
    }),
    setMessage: produce((state, { payload }) => {
      const { messageMap } = payload
      state.messageMap = { ...state.messageMap, ...messageMap }
    }),
    setIpt: produce((state, { payload }) => {
      const { iptVal } = payload
      state.iptVal = { ...state.iptVal, ...iptVal }
    }),
    setFinishDialog: produce((state, { payload }) => {
      const { finishDialog } = payload
      const preDialog = state.finishDialog
      const preLength = preDialog.length
      const nowLength = finishDialog.length
      state.finishDialog = preLength === nowLength ? preDialog : finishDialog
    }),
    resetMessage: produce((state) => {
      state.messageMap = {}
      state.isFinish = false
      state.finishDialog = []
      state.iptVal = {}
      state.focusMessageId = null
      state.orderMsgList = []
      state.customGoodsMsg = {}
    }),
    setCustomGoodsMsg: produce((state, { payload }) => {
      const { goodsMsg, id } = payload
      state.customGoodsMsg = { ...state.customGoodsMsg, [id]: goodsMsg }
    }),
  },
}

export default TrainModel
